var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"column":"","justify-center":"","mt-1":"","mb-3":""}},[_c('o-big-logo'),_vm._v(" "),_c('o-common-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.description)?_c('o-description-title',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-288afa1f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/LogoLayout.vue
// module id = null
// module chunks = 